<template>
  <div id="main" v-if="profile">
    <div class="left-container">
      <left-panel />
    </div>

    <div class="central-container">
      <top-panel />

      <div class="data-container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LeftPanel from '@/components/common/LeftPanel.vue';
import TopPanel from '@/components/top-panel/TopPanel.vue';

export default {
  name: 'app',

  components: {
    TopPanel,
    LeftPanel,
  },

  computed: {
    ...mapGetters({
      profile: 'user/profile',
    }),
  },

  methods: {
    ...mapActions({
      refreshToken: 'user/refreshToken',
      getUserProfile: 'user/getUserProfile',
      changeQuery: 'util/changeQuery',
    }),
  },

  async beforeMount() {
    await this.getUserProfile();
  },

  beforeUpdate() {
    this.changeQuery(null);
  },
};
</script>

<style lang="scss" scoped>
#main {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex: 1;

  .left-container {
    height: 100vh;
    min-width: 220px;
    max-width: 220px;
    box-sizing: border-box;
    border-right: 1px solid var(--dividing-line-color);
  }

  .central-container {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;

    .data-container {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 64px);
      background: var(--grey-background-color);
      box-sizing: border-box;
      overflow: auto;
      padding: 20px;
    }
  }
}
</style>
